import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';
import ReactTable from 'react-table';
import Switch from "react-switch";
import Config from '../../Util/config';
import HttpUtil from '../../Util/httpUtil';
import { withRouter } from 'react-router-dom';

const administrador = localStorage.getItem("Administrador") === 'true';

const vendas = localStorage.getItem("usuarioVendas") === 'true';
class SimularAcesso extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filtroCliente: '',
            filtroID: '',
            filtroUsuario: '',
            buscarPRO: vendas ? true : false,
            lista: [],
            loading: false,
            pageSize: 10,
            columns: [
                {
                    Header: 'ID',
                    className: 'text-center',
                    accessor: 'CodUsuario'
                },
                {
                    Header: 'Cliente',
                    className: 'text-center',
                    accessor: 'NomeUsuario'
                },
                {
                    Header: 'Usuário',
                    className: 'text-center',
                    accessor: 'Login'
                },
                {
                    Header: '',
                    maxWidth: 50,
                    className: 'text-center',
                    Cell: row => (
                        <i class="ecoico fas fa-share text-info" onClick={() => this.simular(row.original)}></i>
                    )
                }
            ],
        }
    }

    buscarLista() {
        return new Promise((resolve, reject) => {
            let url = `${Config.urls.API_URL_BASE}Acesso/BuscarListaUsuarios?`;

            var parametros = 'nome=' + this.state.filtroCliente;
            parametros += (parametros ? '&' : '') + 'id=' + this.state.filtroID;
            parametros += (parametros ? '&' : '') + 'codigo=' + this.state.filtroUsuario;
            parametros += (parametros ? '&' : '') + 'pro=' + this.state.buscarPRO;

            url += parametros;

            HttpUtil.eco_GET(
                url,
                response => {
                    resolve({ rows: response.data });
                },
                () => {
                    console.log('Error');
                }
            );
        });
    };

    filtrar = (event) => {
        event.preventDefault();
        this.setState({ loading: true });
        this.buscarLista().then(res => {
            this.setState({
                lista: res.rows,
                loading: false
            });
        });
    };

    simular = (usuario) => {
        if (usuario.isPro) {
            localStorage.setItem("CodUsuario_OLD", localStorage.getItem("CodUsuario"));
            localStorage.setItem("isSimulacao", true);
            localStorage.setItem("CodUsuario", usuario.CodPro);
            localStorage.setItem("NomeUsuario", usuario.NomeUsuario);
            localStorage.setItem("Administrador", false);
            localStorage.setItem("isPro", true);
            localStorage.setItem("Token", usuario.Login);
            
            window.location = "/arquivos-recentes";
        }
        else {
            var url = `${Config.urls.API_URL_BASE}Acesso/ValidarDadosLogin/${usuario.CodUsuario}`;

            return new Promise((resolve, reject) => {
                HttpUtil.eco_GET(url, (response) => {
                    if (response.data == null || response.data == "") {
                        window.location = "/erro";
                    } else {
                        localStorage.setItem("CodUsuario_OLD", localStorage.getItem("CodUsuario"));
                        localStorage.setItem("isSimulacao", true);

                        localStorage.setItem("CodUsuario", response.data.CodUsuario);
                        localStorage.setItem("NomeUsuario", response.data.NomeUsuario);
                        localStorage.setItem("Login", response.data.Login);
                        localStorage.setItem("Email", response.data.Email);
                        localStorage.setItem("NomePerfil", response.data.NomePerfil);
                        localStorage.setItem("Administrador", response.data.Administrador);
                        localStorage.setItem("TermoUso", response.data.TermoUso);
                        localStorage.setItem("roles", JSON.stringify(response.data.Roles));
                        localStorage.setItem("Hash", response.data.Hash);
                        localStorage.setItem("isContribuicaoPiloto", response.data.isContribuicaoPiloto);
                        localStorage.setItem("ExibirNotificacaoArquivosRecentes", response.data.ExibirNotificacaoArquivosRecentes);
                        localStorage.setItem("isPro", response.data.isPro);
                        localStorage.setItem("Token", "");

                        window.location = "/arquivos-recentes";
                    }
                }, () => { window.location = "/erro"; });
            });

        }
    };

    handleChange = (checked) => {
        this.state.columns[2].Header = checked ? 'Token' : 'Usuário';
        this.setState({ buscarPRO: checked });
    }

    componentDidMount() {
        if (!administrador)
            this.props.history.goBack();

        this.inputFiltroCliente.focus();
    }

    render() {
        return (
            <Container>
                <section className="cabecalho">
                    <label className="page-title">Simulação de Acesso</label>
                </section>
                <section className="filtros">
                    <form onSubmit={this.filtrar}>
                        <Row>
                            <Col xs={2}>
                                <div className="form-group">
                                    <label className="control-label">ID</label>
                                    <input
                                        className="ecoforms form-control"
                                        type="text"
                                        onChange={e => {
                                            this.state.filtroID = e.target.value;
                                        }}
                                    />
                                </div>
                            </Col>
                            <Col xs={4}>
                                <div className="form-group">
                                    <label className="control-label">Cliente</label>
                                    <input
                                        className="ecoforms form-control"
                                        type="text"
                                        ref={(input) => { this.inputFiltroCliente = input; }}
                                        onChange={e => {
                                            this.state.filtroCliente = e.target.value;
                                        }}
                                    />
                                </div>
                            </Col>
                            <Col xs={2}>
                                <div className="form-group">
                                    <label className="control-label">{this.state.buscarPRO ? 'Token' : 'Usuário'}</label>
                                    <input
                                        className="ecoforms form-control"
                                        type="text"
                                        onChange={e => {
                                            this.state.filtroUsuario = e.target.value;
                                        }}
                                    />
                                </div>
                            </Col>
                            {!vendas &&
                                <Col xs={1}>
                                    <div className="form-group">
                                        <label className="control-label">PRO</label>
                                        <Switch
                                            onChange={this.handleChange}
                                            id="buscarPRO"
                                            className={this.state.buscarPRO ? 'active' : ''}
                                            checked={this.state.buscarPRO}
                                            uncheckedIcon={false}
                                            checkedIcon={false} />
                                    </div>
                                </Col>
                            }
                            <Col xs={1}>
                                <div className="form-group">
                                    <label className="control-label">Exibir</label>
                                    <select className="ecoforms form-control" onChange={e => {
                                        this.setState({ pageSize: parseInt(e.target.value) });
                                    }}>
                                        <option value="10">10</option>
                                        <option value="25">25</option>
                                        <option value="50">50</option>
                                        <option value="100">100</option>
                                        <option value="1000">1000</option>
                                    </select>
                                </div>
                            </Col>
                            <Col xs={2}>
                                <button type="submit" className="ecobtn fat baby-blue form-group-btn btn-block">Filtrar</button>
                            </Col>
                        </Row>
                    </form>
                </section>
                <section className="resultado">
                    <ReactTable
                        key={this.state.pageSize}
                        data={this.state.lista}
                        columns={this.state.columns}
                        loading={this.state.loading}
                        className="eco-react-table"
                        pageSize={this.state.pageSize}
                        showPagination={this.state.lista.length > this.state.pageSize}
                    />
                </section>
            </Container>
        );
    }
}

export default withRouter(SimularAcesso);


// WEBPACK FOOTER //
// ./src/Componente/SimularAcesso/SimularAcesso.jsx